import styled from '@emotion/styled';
import { Checkbox } from 'antd';
import type { CheckboxProps } from 'antd';
import React from 'react';

import colors from 'config/theme/colors';

const Group = styled(Checkbox.Group)`
  display: flex;
  justify-content: center;
`;

const StyledCheckbox = styled(Checkbox)`
  height: 100px;
  width: 100px;
  background: ${colors['@menu-item-active-bg']};
  border-radius: 4px;

  &:not(:last-child) {
    margin-right: 16px;
  }

  &:hover,
  &:focus,
  &:active {
    span {
      color: rgba(0, 114, 206, 0.75) !important;
    }
  }

  &.ant-checkbox-wrapper-checked {
    border: 3px solid ${colors['@primary-color']};
    &:hover {
      border-color: rgba(0, 114, 206, 0.75);
      span {
        color: rgba(0, 114, 206, 0.75) !important;
      }
    }
    span {
      color: ${colors['@primary-color']} !important;
    }
  }

  .ant-checkbox {
    display: none;
  }

  span {
    transition: all 0.3s ease-out;
    padding: 0 !important;
  }

  > .ant-checkbox-label {
    width: 100%;
    height: 100%;
  }
`;

const Card = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${colors['@text-color-secondary']};
`;

type CheckboxCardsProps = CheckboxProps & { 'data-cy'?: string };

const CheckboxCards: React.FC<CheckboxCardsProps> & { Group: typeof Group } = ({ children, 'data-cy': dataCy, ...rest }) => (
  <StyledCheckbox {...rest}>
    <Card data-cy={dataCy}>{children}</Card>
  </StyledCheckbox>
);

CheckboxCards.Group = Group;

export default CheckboxCards;
